import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { NavLink as RouterLink } from 'react-router-dom';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Collapse, ListItem } from '@mui/material';

const style = {
  '& a': {
    display: 'inline-flex',
    justifyContent: 'flex-start',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    width: '100%',
    color: 'colors.neutral900',
    height: 36,
    padding: 1,
    minWidth: 0,
  },
  '& a.active': {
    color: 'colors.neutral900',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px',
    backgroundColor: 'colors.green100',
    borderRadius: 2,
  },
  height: 36,
  paddingTop: 1,
  paddingBottom: 0,
};

export interface NavItemInterface {
  id: string;
  titleIntlId: string;
  href?: string;
  items?: NavItemInterface[];
  hidden?: boolean;
}

interface NavItemProps {
  titleIntlId: string;
  href?: string;
  children?: React.ReactNode;
  open?: boolean;
  disabled: boolean;
}

const NavItem: React.FC<NavItemProps> = ({
  titleIntlId,
  href = '/',
  children,
  open: openProp,
  disabled,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(openProp);
  const intl = useIntl();

  const handleToggle = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  if (children) {
    return (
      <ListItem disableGutters key={titleIntlId} {...rest} sx={style}>
        <Button
          color="secondary"
          onClick={handleToggle}
          disableRipple
          disableFocusRipple
          disabled={disabled}
        >
          {intl.formatMessage({ id: titleIntlId })}
          {isOpen ? <ExpandLessIcon color="inherit" /> : <ExpandMoreIcon color="inherit" />}
        </Button>
        <Collapse in={isOpen}>{children}</Collapse>
      </ListItem>
    );
  }

  return (
    <ListItem disableGutters key={titleIntlId} {...rest} sx={style}>
      <Button
        color="secondary"
        component={RouterLink}
        to={href}
        disableRipple
        disableFocusRipple
        disabled={disabled}
      >
        {intl.formatMessage({ id: titleIntlId })}
      </Button>
    </ListItem>
  );
};

export default NavItem;
